import { get, ajax } from './pmall-base';

/**
 * 获取车系列表数据
 * @param {*} {brandCode: 1荣威 2名爵}
 */
// 获取九宫格数据
const getLotteryInfo = (data) => get('index.php/openapi/lottery/call', data);

// 抽奖
const startDraw = (data) => get('index.php/openapi/lottery/call', data);

// 抽奖机会加1
const addLottery1 = (data) => get('index.php/openapi/lottery/call', data);

// 兑换抽奖机会
const exchangePoint = (data) => get('index.php/openapi/lottery/call', data);

// 增加抽奖次数
const activityExchangeNumAdaptation = (data) => ajax('/index.php/openapi/lottery/call?method=activityExchangeNumAdaptation', data);
export default {
  getLotteryInfo,
  startDraw,
  exchangePoint,
  addLottery1,
  activityExchangeNumAdaptation,
};
